module.exports = __webpack_public_path__ + "img/zhoubao.cb41a1ac.png";